// dependencies imports ⇒
import React, { useState, useEffect, useRef } from "react";
import { Box, Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
// assets and scss imports ⇒
import "./pandingAmountContainer.scss";
import useIsMobile from "../../../Util/Helper/useIsMobile";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";
import { GET_PENDING_AMOUNT_LIST } from "../apiConstants";
import { connect, unsubscribeWebSocket } from "../../../Util/webSocketHelper";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../../../Util/constants";

const PendingAmountContainer = (props) => {
  const { appointment, disconnectWebSocket, setIsPendingView } = props;
  // Constants ====>

  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dueAmountList, setDueAmountList] = useState([]);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const token = localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorAssociatedToClinic = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );

  const isMobile = useIsMobile();
  const history = useHistory();
  const prevClinicId = useRef();

  // Life Cycle methods ===>

  useEffect(() => {
    if (userType === USER_TYPE.STAFF && !clinicId) {
      return () => {
        unsubscribeWebSocket(clinicId, userId, userType);
      };
    }
  }, [disconnectWebSocket]);

  useEffect(() => {
    connect(
      token,
      clinicId,
      prevClinicId.current,
      userId,
      socketResponseCallback,
      userType
    );
    prevClinicId.current = clinicId;
  }, []);

  useEffect(() => {
    getPendingAmountList();
  }, [appointment?.clinic_id, appointment?.doctor_id]);

  // Api call ==>

  const socketResponseCallback = (res) => {
    if (res.data !== "null") {
      let data = JSON.parse(res.data);
      console.log("data", data);
      if (data?.id === "raise-invoice") {
        getPendingAmountList();
      }
    }
  };

  const getPendingAmountList = () => {
    setLoading(true);
    let payLoad = {
      clinic_id: appointment?.clinic_id,
      doctor_id: appointment?.doctor_id,
      patient_account_id: appointment?.patient_account_id,
    };
    const resData = c2cPostApiHandler(GET_PENDING_AMOUNT_LIST, payLoad);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.data?.length > 0) {
          setIsPendingView(true);
          setDueAmountList(res?.data?.data);
        } else {
          setDueAmountList([]);
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  //   Actions ===>

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleOnDueAmount = (item) => {
    localStorage.setItem(
      "desciptionPropsPatientAcctId",
      appointment.patient_account_id
    );
    const newTab = window.open();
    let path = `${
      doctorAssociatedToClinic ? "/clinic" : "/doctor"
    }/account/mypatients/${appointment?.patient_account_id}?start_date=${
      item?.appointment_date
    }&end_date=${item?.appointment_date}`;
    newTab.location.href = history.createHref({
      pathname: path,
    });
  };

  //   Create UI ===>

  // Skeleton
  const renderSkeletons = (count) =>
    Array.from({ length: count }).map((_, index) => (
      <div className="skeleton-card" key={index}>
        <Box mb={2}>
          <Skeleton variant="text" width={185} height={30} />
          <Skeleton variant="text" width={180} height={25} />
          <Skeleton
            variant="rectangular"
            width={130}
            height={35}
            style={{ borderRadius: "20px", marginTop: "15px" }}
          />
        </Box>
      </div>
    ));

  // Payment Due Card ===>
  const paymentCardUi = (item, ind) => {
    return (
      <div className="ppc-payment-card" key={ind}>
        <div className="ppc-payment-card-values">
          <div class="ppc-info-container">
            <div class="ppc-info-item">
              <span class="ppc-info-label">Date</span>
              <span class="ppc-info-separator">:</span>
              <span class="ppc-info-value">{item?.appointment_date}</span>
            </div>
            <div class="ppc-info-item">
              <span class="ppc-info-label">Due Amount</span>
              <span class="ppc-info-separator">:</span>
              <span class="ppc-info-value">₹{item?.pending_amount}</span>
            </div>
          </div>
        </div>
        <div className="ppc-sapartor" />
        <div className="ppc-pay-button-cont">
          <button
            className="ppc-pay-button"
            onClick={() => handleOnDueAmount(item)}
          >
            Pay Due Amount
          </button>
        </div>
      </div>
    );
  };

  // Mobile UI
  const pendingAmountMobileUi = () => (
    <div
      className={`panding-payment-mobile-container ${
        isExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="ppc-header">
        <h3 className="ppc-heading">PENDING PAYMENTS</h3>
        <button className="ppc-toggle-button" onClick={toggleExpand}>
          <div className="ppc-btn-icon">{isExpanded ? "-" : "+"}</div>
        </button>
      </div>
      {isExpanded && (
        <div className="ppmc-payments-list">
          {loading
            ? renderSkeletons(3)
            : dueAmountList.map((payment, index) =>
                paymentCardUi(payment, index)
              )}
        </div>
      )}
    </div>
  );

  // Desktop UI
  const pendingAmountUi = () => (
    <div className="panding-payment-web-container">
      <div className="ppc-header">
        <h3 className="ppc-heading">PENDING PAYMENTS</h3>
      </div>
      <div className="ppwc-payments-list">
        {loading
          ? renderSkeletons(4)
          : dueAmountList.map((payment, index) =>
              paymentCardUi(payment, index)
            )}
      </div>
    </div>
  );

  const pendingAmountView = () => {
    return (
      <div className="panding-amount-container">
        {isMobile ? pendingAmountMobileUi() : pendingAmountUi()}
      </div>
    );
  };

  return <>{dueAmountList.length > 0 && pendingAmountView()}</>;
};

export default PendingAmountContainer;
